import { defineComponent, computed } from '@vue/composition-api';
import __vue_component__ from '../SdsSkeleton/SdsSkeletonEffect.vue.js';
import __vue_component__$1 from '../SdsIcon/SdsIcon.vue.js';

var script = defineComponent({
    name: 'SdsAvatar',
    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
        image: {
            type: String,
            required: false,
            default: '',
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
        iconName: {
            type: String,
            required: false,
            default: ''
        },
        isIconThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasNotification: {
            type: Boolean,
            required: false,
            default: false,
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    setup: function (props) {
        var fallbackIconSize = computed(function () {
            switch (props.size) {
                case 'xxl':
                    return 'xl';
                case 'xl':
                    return 'lg';
                case 'lg':
                    return 'md';
                case 'md':
                    return 'sm';
                case 'sm':
                    return 'xs';
                case 'xs':
                    return 'xs';
            }
        });
        var variant = computed(function () { return props.image ? 'image' : 'text-only'; });
        var statusIconSize = computed(function () { return props.size === 'xxl' ? 'lg' : 'sm'; });
        return {
            variant: variant,
            fallbackIconSize: fallbackIconSize,
            statusIconSize: statusIconSize
        };
    },
    components: {
        SdsSkeletonEffect: __vue_component__,
        SdsIcon: __vue_component__$1
    }
});

export default script;
